import React, { PureComponent } from 'react';
/* eslint-disable */
import { MY_API_URL } from '../QueryMe';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;
import ProfileImage from '../../Apanel/ProfileImage';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
const initialstate = {
	image: localStorage.profile_img,
	collapse: false,
};
export default class TopbarProfilerec extends PureComponent {
	constructor() {
		super();
		this.state = {
			collapse: false,
		};
	}
	state = { ...initialstate };
	toggle = () => {
		this.setState((prevState) => ({ collapse: !prevState.collapse }));
	};
	componentDidMount() {
		if (this.state.image) {
			console.log(this.state.image);
		} else {
			this.setState({ image: dimgurl });
			console.log(this.state.image);
		}
	}
	render() {
		const { collapse } = this.state;

		return (
			<div className="topbar__profile">
				<button type="button" className="topbar__avatar" onClick={this.toggle}>
					<ProfileImage clname="topbar__avatar-img" flpath={this.state.image} />
					<p className="topbar__avatar-name">{localStorage.name}</p>
					<DownIcon className="topbar__icon" />
				</button>
				{collapse && (
					<button
						className="topbar__back"
						type="button"
						onClick={this.toggle}
					/>
				)}
				<Collapse isOpen={collapse} className="topbar__menu-wrap">
					<div className="topbar__menu">
						<TopbarMenuLink
							title="My Profile"
							icon="user"
							path="/profile"
							onClick={this.toggle}
						/>
						{/* <TopbarMenuLink
							title="Calendar"
							icon="calendar-full"
							path="/default_pages/calendar"
							onClick={this.toggle}
						/> */}
						{/* <TopbarMenuLink
							title="Tasks"
							icon="list"
							path="/todo"
							onClick={this.toggle}
						/> */}
						{/* <TopbarMenuLink
							title="Inbox"
							icon="inbox"
							path="/mail"
							onClick={this.toggle}
						/> */}
						<div className="topbar__menu-divider" />

						{/* <TopbarMenuLink
							title="Lock Screen"
							icon="lock"
							path="/lock_screen"
							onClick={this.toggle}
						/> */}
						<TopbarMenuLink
							title="Log Out"
							icon="exit"
							path="/logout"
							onClick={this.toggle}
						/>
					</div>
				</Collapse>
			</div>
		);
	}
}
